module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.adec7d6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/fontawesome-6.6.0/webfonts/fa-solid-900.ttf
// module id = djpN
// module chunks = 2